import { render, staticRenderFns } from "./FormatRegister.vue?vue&type=template&id=2bdf7bac"
import script from "./FormatRegister.vue?vue&type=script&lang=js"
export * from "./FormatRegister.vue?vue&type=script&lang=js"
import style0 from "./FormatRegister.vue?vue&type=style&index=0&id=2bdf7bac&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports